import { SearchRegistry } from '../types';

// Note: the former "Settings" search entries (API Credentials, UI
// Customization, Data Validation, Fraud Rules) moved to
// `./integration-and-settings.ts` as `integrationAndSettingsSearchEntries`.

export const settingsAndSupportSearchEntries: SearchRegistry = {
  // -- Support & Feedback --
  '/support-and-feedback/requests/submit': {
    keywords: [
      'submit request',
      'support request',
      'feedback',
      'open ticket',
      'contact support',
      'help request',
      'submit feedback',
      'bug report',
      'feature request',
      'support kontakt',
      'submit ticket',
      'attach screenshot',
      'attach order id',
      'feedback attachment',
    ],
    questions: [
      'How do I open a support ticket?',
      'Where do I submit feedback or a bug report?',
      'How do I contact ryd support?',
      'Can I attach a screenshot to a support request?',
    ],
    faqs: [
      {
        q: 'How do I report a bug or request help from ryd support?',
        a: 'Open Support & Feedback → Requests → Submit Request. Fill in the form, attach any screenshots or order IDs, and the request lands with the right team. You can track responses in My Requests.',
      },
    ],
  },
  '/support-and-feedback/requests': {
    keywords: [
      'my requests',
      'support tickets',
      'my tickets',
      'feedback history',
      'submitted requests',
      'request history',
      'request status',
      'open requests',
      'closed requests',
      'follow up ticket',
    ],
    questions: [
      'Where do I see the support requests I have submitted?',
      'How do I follow up on an existing support ticket?',
      'How do I check the status of my open requests?',
    ],
  },

  // -- Portal Information --
  '/portal-changelog': {
    keywords: [
      'portal changelog',
      'changelog',
      'portal updates',
      'release notes',
      'whats new',
      'portal release notes',
      'updates',
      'portal version history',
      'feature announcements',
      'recent changes',
    ],
    questions: [
      'What changed recently in the portal?',
      'Where is the portal changelog?',
      'When was feature X released in the portal?',
    ],
  },
  '/sitemap': {
    keywords: [
      'sitemap',
      'portal sitemap',
      'all pages',
      'navigation',
      'page index',
      'site index',
      'site map',
      'sitemap tree',
      'page directory',
    ],
    questions: [
      'Where is the portal sitemap?',
      'How do I see every page available in the portal?',
      'How do I find a page when I cannot remember its menu location?',
    ],
  },
};
